import { objectSelector } from 'theme/utils';

const PERMISSION = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/permissions`);

class Permission {
  constructor({ pk, name, slug, namespacePath, isVisibleForStaff }) {
    this.pk = pk;
    this.name = name;
    this.slug = slug;
    this.namespacePath = namespacePath;
    this.isVisibleForStaff = isVisibleForStaff;
  }
}

export const permissionsMapper = (permissions = []) => {
  return permissions.map((item) => {
    return new Permission({
      pk: objectSelector(item, PERMISSION.PERMISSION.PK),
      name: objectSelector(item, PERMISSION.PERMISSION.NAME),
      slug: objectSelector(item, PERMISSION.PERMISSION.SLUG),
      namespacePath: objectSelector(item, PERMISSION.PERMISSION.NAMESPACE_PATH),
      isVisibleForStaff: objectSelector(
        item,
        PERMISSION.PERMISSION.IS_VISIBLE_FOR_STAFF
      ),
    });
  });
};



// WEBPACK FOOTER //
// ./src/models/permissions.js